import { useXMessage } from '@/components/XMessage/useXMessage'
import { setGlobalMessage } from '@/utils/message'
import { useI18n } from './useI18n'

export const useMessage = () => {
  const { t } = useI18n()
  const msg = useXMessage()
  setGlobalMessage(msg)

  return {
    info(content: string) {
      msg.info(content)
    },
    error(content: string) {
      msg.error(content)
    },
    success(content: string) {
      msg.success(content)
    },
    warning(content: string) {
      msg.warning(content)
    },
    alert(content: string) {
      window.alert(content)
    },
    alertError(content: string) {
      window.alert(content)
    },
    alertSuccess(content: string) {
      window.alert(content)
    },
    alertWarning(content: string) {
      window.alert(content)
    },
    notify(content: string) {
      msg.info(content)
    },
    notifyError(content: string) {
      msg.error(content)
    },
    notifySuccess(content: string) {
      msg.success(content)
    },
    notifyWarning(content: string) {
      msg.warning(content)
    },
    confirm(content: string, tip?: string) {
      const text = tip ? `${tip}\n${content}` : content
      return Promise.resolve(window.confirm(text)).then(ok => (ok ? Promise.resolve() : Promise.reject()))
    },
    delConfirm(content?: string, tip?: string) {
      const text = content || t('common.delMessage')
      const title = tip || t('common.confirmTitle')
      return Promise.resolve(window.confirm(`${title}\n${text}`)).then(ok => (ok ? Promise.resolve() : Promise.reject()))
    },
    exportConfirm(content?: string, tip?: string) {
      const text = content || t('common.exportMessage')
      const title = tip || t('common.confirmTitle')
      return Promise.resolve(window.confirm(`${title}\n${text}`)).then(ok => (ok ? Promise.resolve() : Promise.reject()))
    },
    prompt(content: string, tip: string) {
      const result = window.prompt(tip || t('common.confirmTitle'), content)
      return result !== null ? Promise.resolve({ value: result }) : Promise.reject()
    }
  }
}
